module.exports = __webpack_public_path__ + "img/notas.e08ff3d3.svg";